import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from 'primereact/button';
import { Checkbox } from "primereact/checkbox";
import { useState } from "react";
import { withTranslation } from "react-i18next";
import PaymentAcknowledgeWrapper from "./PaymentAcknowledge.style";

function PaymentAcknowledge({i18n, acknowledgements, setAckAgree}) {
    const [agreements, setAgreement] = useState(['1', '2', '3']);
    const onAgreementChange = (e) => {
        let selectedAgreements = [...agreements];
        if(e.checked)
            selectedAgreements.push(e.value);
        else
            selectedAgreements.splice(selectedAgreements.indexOf(e.value), 1);
            setAgreement(selectedAgreements);
        setAckAgree(selectedAgreements.includes('1') && selectedAgreements.includes('2') && selectedAgreements.includes('3'));
    }
    const [activeIndex, setActiveIndex] = useState(null);

    const onChangeTab = (itemIndex) => {
        let _activeIndex = activeIndex ? [...activeIndex] : [];

        if (_activeIndex.length === 0) {
        _activeIndex.push(itemIndex);
        } else {
        const index = _activeIndex.indexOf(itemIndex);
        if (index === -1) {
            _activeIndex.push(itemIndex);
        } else {
            _activeIndex.splice(index, 1);
        }
        }

        setActiveIndex(_activeIndex);
    };
    return (
        <PaymentAcknowledgeWrapper>
            <div>
                <p><p>{i18n.t('ByContinuing')}</p></p>
            </div>
            <div className="mb-3 d-flex align-items-center">
                <Checkbox inputId="ack1" value='1' onChange={onAgreementChange} checked={agreements.includes('1')}></Checkbox>
                <label htmlFor="ack1">{i18n.t('DoYouConfirmThe') + " "} <Button className="p-button-link p-0" onClick={() => onChangeTab(0)}> {i18n.t('Declaration')}</Button>  {i18n.t('OnBehalfOfAllPersonsToBeInsured')}</label>
            </div>
            <div className="col-12">
              <Accordion
                multiple
                activeIndex={activeIndex}
                onTabChange={(e) => setActiveIndex(e.index)}
              >
                <AccordionTab >
                  <div className="ack_description">
                    Text
                  </div>
                </AccordionTab>
              </Accordion>
            </div>
            <div className="mb-3 d-flex align-items-center">
                <Checkbox inputId="ack2" value='2' onChange={onAgreementChange} checked={agreements.includes('2')}></Checkbox>
                <label htmlFor="ack2">{i18n.t('HaveYouReadThe') + " "} <Button className="p-button-link p-0">{i18n.t('PolicyTerms') + " "} </Button></label>
            </div>
            <div className="mb-3 d-flex align-items-center">
                <Checkbox inputId="ack3" value='3' onChange={onAgreementChange} checked={agreements.includes('3')}></Checkbox>
                <label htmlFor="ack3">{i18n.t('IAcknowledgeToRead') + " "} <Button className="p-button-link p-0" >{i18n.t('UnifiedInsuranceForm')}</Button></label>
            </div>
        
            
        </PaymentAcknowledgeWrapper>
    );
}

export default withTranslation()(PaymentAcknowledge);